export const kvProtocol = {
    protocolID: 0,
    key: 1,
    value: 2,
    controller: 3,
    tags: 4,
    signature: 5 // Note: signature moves to position 5 when tags are present
};
//# sourceMappingURL=types.js.map